import { useMutation } from "@tanstack/react-query";
import { httpRequest } from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";
import { FinanceCategoryResponse } from "@/types";

export type UpdateFinanceCategoryRequestDTO = {
  id: string;
  name: string;
};

async function updateFinanceCategory(
  request: UpdateFinanceCategoryRequestDTO
): Promise<FinanceCategoryResponse> {
  const { id, ...updateData } = request;

  const response = await httpRequest.put<FinanceCategoryResponse>(
    `/finance-categorie-entries/${id}`,
    updateData
  );
  return response.data;
}

export function useUpdateFinanceCategoryMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateFinanceCategory,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["finance-categorie-entries"],
      });
    },
  });
}
